export const facebookUrl = 'https://facebook.com';
export const twitterUrl = 'https://twitter.com';
export const linkedinUrl = 'https://linkedin.com';
export const instagramUrl = 'https://instagram.com';
export const youtubeUrl = 'https://youtube.com';
export const glassdoorUrl = 'https://glassdoor.com';
// note - for wechat we do not append their website to the url. Instead we take the value from the DB directly to use as the social link
